var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getConfigStatus
    ? _c(
        "div",
        [
          _c("header-tabs", { attrs: { active: _vm.$route.path } }),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      background: "#f3f3f3",
                      height: "50px",
                      "line-height": "30px",
                      padding: "0 25px",
                      display: "flex",
                      "align-items": "center"
                    }
                  },
                  [
                    _c("div", [_vm._v("仓区优势级别定义 ：")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "auto" },
                        attrs: { type: "success", size: "spaceSetting" },
                        on: {
                          click: function($event) {
                            _vm.dialogVisible = true
                          }
                        }
                      },
                      [_vm._v("设置")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-bottom": "0" } }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { padding: "10px 25px" } },
                  [
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 2 } }, [
                          _vm._v("\n            库存仓区:\n          ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 22 } },
                          _vm._l(_vm.form.stock, function(area) {
                            return _c(
                              "el-button",
                              { key: area, attrs: { size: "small" } },
                              [_vm._v(_vm._s(area))]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 2 } }, [
                          _vm._v("\n            发货仓区:\n          ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 22 } },
                          _vm._l(_vm.form.fahuo, function(area) {
                            return _c(
                              "el-button",
                              { key: area, attrs: { size: "small" } },
                              [_vm._v(_vm._s(area))]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 7 } }, [
                          _vm._v(
                            "\n            库存仓区是否单独生成越库拣货任务：\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 17 } },
                          [
                            _c("el-switch", {
                              attrs: { "active-value": 1, "inactive-value": 0 },
                              model: {
                                value: _vm.form.picking_alone,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "picking_alone", $$v)
                                },
                                expression: "form.picking_alone"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      background: "#f3f3f3",
                      height: "50px",
                      "line-height": "30px",
                      padding: "0 25px",
                      display: "flex",
                      "align-items": "center"
                    }
                  },
                  [_c("div", [_vm._v("库存分离设置 ：")])]
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-bottom": "0" } }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { padding: "10px 25px" } },
                  [
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 3 } }, [
                          _vm._v("\n            是否开启库存分离：\n          ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 20 } },
                          [
                            _c("el-switch", {
                              attrs: { "active-value": 1, "inactive-value": 0 },
                              model: {
                                value: _vm.form.stock_dabiao,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "stock_dabiao", $$v)
                                },
                                expression: "form.stock_dabiao"
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.form.method, function(method) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: method,
                                  attrs: {
                                    disabled:
                                      _vm.form.stock_dabiao == 1 ? false : true,
                                    checked: method.value == "1" ? true : false,
                                    label: method.label,
                                    "true-label": "1",
                                    "false-label": "0"
                                  },
                                  model: {
                                    value: method.value,
                                    callback: function($$v) {
                                      _vm.$set(method, "value", $$v)
                                    },
                                    expression: "method.value"
                                  }
                                },
                                [_vm._v(_vm._s(method.label))]
                              )
                            })
                          ],
                          2
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 10 } }, [
                          _vm._v(
                            "\n            PC点货同一上架单内同一SKU有配货时未预配到订单的商品是否分离库存：\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 14 } },
                          [
                            _c("el-switch", {
                              attrs: { "active-value": 1, "inactive-value": 0 },
                              model: {
                                value: _vm.form.pc_tally_stock_dabiao,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "pc_tally_stock_dabiao",
                                    $$v
                                  )
                                },
                                expression: "form.pc_tally_stock_dabiao"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 7 } }, [
                          _vm._v(
                            "\n            未预配到订单的商品上架至库存仓区时是否配货：\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 17 } },
                          [
                            _c("el-switch", {
                              attrs: { "active-value": 1, "inactive-value": 0 },
                              model: {
                                value: _vm.form.stock_upshelf_allot,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "stock_upshelf_allot", $$v)
                                },
                                expression: "form.stock_upshelf_allot"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 6 } }, [
                          _vm._v(
                            "\n            前置仓商品未预配到订单是否库存分离：\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 17 } },
                          [
                            _c("el-switch", {
                              attrs: { "active-value": 1, "inactive-value": 0 },
                              model: {
                                value: _vm.form.pre_storage_goods_unallot,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "pre_storage_goods_unallot",
                                    $$v
                                  )
                                },
                                expression: "form.pre_storage_goods_unallot"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticStyle: { color: "#F00" } }, [
                              _vm._v(
                                "（开启后则前置仓商品只需判断是否有预配，且优先级最高，不参与其他库存分离判断）"
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 4 } }, [
                          _vm._v(
                            "\n            提前预测商品不参与库存分离：\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 17 } },
                          [
                            _c("el-switch", {
                              attrs: { "active-value": 1, "inactive-value": 0 },
                              model: {
                                value: _vm.form.forecast_plan_goods,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "forecast_plan_goods", $$v)
                                },
                                expression: "form.forecast_plan_goods"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 2 } }, [
                          _vm._v("\n            未动销设置：\n          ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 17 } },
                          [
                            _vm._v("\n            SKU超过\n            "),
                            _c("el-inputNumber", {
                              attrs: { size: "mini", min: 0, precision: 0 },
                              model: {
                                value: _vm.form.moving_sales_days,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "moving_sales_days", $$v)
                                },
                                expression: "form.moving_sales_days"
                              }
                            }),
                            _vm._v(
                              "\n            天没有出库的进行库存分离\n          "
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    },
                    [_vm._v(" 保 存 ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "设置仓区",
                visible: _vm.dialogVisible,
                width: "40%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogVisible = $event
                }
              }
            },
            [
              _c("el-transfer", {
                attrs: { data: _vm.allArea },
                model: {
                  value: _vm.fahuo,
                  callback: function($$v) {
                    _vm.fahuo = $$v
                  },
                  expression: "fahuo"
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c("el-button", { on: { click: _vm.resetStockFahuo } }, [
                    _vm._v("取 消")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleStockFahuo }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f6b479e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f6b479e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/StockDetailSeparateSetting.vue
// module id = null
// module chunks = 